// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view-select[data-v-3a27e436] {\n  width: 100%;\n  height: 40px;\n}\n.view-select .addClass[data-v-3a27e436] {\n  position: absolute;\n  width: 84px;\n  height: 40px;\n  font-size: 14px;\n  font-family: Microsoft YaHei-Regular, Microsoft YaHei;\n  font-weight: 400;\n  color: #1258bc;\n  line-height: 40px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
